<template>
  <div
    class="background animate__animated animate__fadeIn"
    style="height: 100vh; position: relative"
  >
    <!-- SECTION: ANUNCIO -->
    <div
      v-show="show['anuncio']"
      class="background"
      style="
        height: 100vh;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9;
      "
    >
      <div
        style="
          height: calc(100vh - 60px);
          width: 100%;
          position: fixed;
          top: 0;
          left: 0;
        "
      >
        <div style="height: calc(100vh - 60px); width: 100%">
          <ins
            class="adsbygoogle"
            style="display: block"
            data-ad-client="ca-pub-5752844063568531"
            data-ad-slot="6942249464"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></ins>
        </div>
      </div>
      <div
        style="height: 60px; width: 100%; position: fixed; bottom: 0; left: 0"
        class="p-3"
      >
        <button
          class="button is-yellow shadow-md text-blue-500 w-full disabled:opacity-50 disabled:shadow-none"
          :disabled="!!anuncio_countdown"
          @click="onCloseAdClicked()"
        >
          Cerrar anuncio<span
            id="anuncio_separador"
            style="opacity: 0.25"
            v-show="anuncio_countdown"
            >&nbsp;|&nbsp;</span
          ><span
            id="anuncio_countdown"
            style="opacity: 0.5"
            v-show="anuncio_countdown"
            >{{ anuncio_countdown }}</span
          >
        </button>
      </div>
    </div>
    <!-- !SECTION: ANUNCIO -->

    <div style="height: 30vh; position: relative" class="text-center">
      <div style="clear: both; height: 40%"></div>
      <div
        class="animate__animated animate__pulse animate__faster title"
        style="position: relative; z-index: 2"
      >
        <div
          style="font-size: 50px; text-shadow: 6px 6px 16px rgba(0, 0, 0, 0.3)"
        >
          <b class="text-white">GAME OVER</b>
        </div>
      </div>
    </div>

    <div style="height: 50vh; position: relative" class="text-center">
      <div class="mx-auto" style="width: 320px">
        <div
          class="animate__animated animate__fast animate__fadeInDown px-4 text-white text-1xl"
          v-show="show['success']"
        >
          <div class="text-left inline-block" style="width: 200px">
            <i class="fas fa-check text-green-300" style="width: 32px"></i>
            ACIERTOS
          </div>
          <div class="text-right inline-block" style="width: 80px">
            <span style="opacity: 0.35">+</span>
            {{ success }}
          </div>
        </div>
        <div
          class="animate__animated animate__fast animate__fadeInDown px-4 text-white text-1xl"
          v-show="show['fails']"
        >
          <div class="text-left inline-block" style="width: 200px">
            <i
              class="fas fa-times text-red-300"
              style="width: 32px; position: relative; left: 2px"
            ></i>
            FALLOS
          </div>
          <div class="text-right inline-block" style="width: 80px">
            <span style="opacity: 0.35">-</span>
            {{ fails }}
          </div>
        </div>
        <div
          class="animate__animated animate__fast animate__fadeInDown px-4 text-white text-1xl"
          v-show="show['time']"
        >
          <div class="text-left inline-block" style="width: 200px">
            <i class="fas fa-stopwatch text-purple-300" style="width: 32px"></i>
            TIEMPO MÁX.
          </div>
          <div class="text-right inline-block" style="width: 80px">
            <span style="opacity: 0.35">x</span>
            {{ maxTime }}
          </div>
        </div>
        <div
          class="animate__animated animate__fast animate__fadeInDown px-4 text-white text-1xl"
          v-show="show['level']"
        >
          <div class="text-left inline-block" style="width: 200px">
            <i
              class="fas fa-arrow-circle-up text-teal-300"
              style="width: 32px"
            ></i>
            NIVEL MÁX.
          </div>
          <div class="text-right inline-block" style="width: 80px">
            <span style="opacity: 0.35">x</span>
            {{ maxLevel }}
          </div>
        </div>
        <div
          class="animate__animated animate__fast animate__fadeInDown my-4 py-2 px-4 text-white text-3xl"
          v-show="show['score']"
        >
          <div class="text-left inline-block font-bold" style="width: 200px">
            <i
              class="fas fa-stars text-yellow-300"
              style="width: 32px; position: relative; left: -6px"
            ></i>
            PUNTOS
          </div>
          <div class="text-right inline-block font-bold" style="width: 80px">
            {{ score }}
          </div>
        </div>
        <div
          class="animate__animated animate__fast animate__fadeInDown py-2 px-4 text-white text-1xl"
          v-show="show['record']"
        >
          <div class="text-left inline-block" style="width: 200px">
            <i class="fas fa-medal text-orange-300" style="width: 32px"></i> TU
            RECORD
          </div>
          <div class="text-right inline-block" style="width: 80px">
            {{ record }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="section text-center"
      style="position: absolute; bottom: 4rem; width: 100%"
    >
      <div>
        <button
          @click="onRetryClicked()"
          class="button is-large is-yellow text-blue-500 shadow-lg animate__animated animate__fast animate__bounceIn"
          v-show="show['retry']"
        >
          Reintentar
        </button>
      </div>
      <div class="mt-6">
        <button
          @click="onBackClicked()"
          class="button bg-transparent text-white text-2xl animate__animated animate__fast animate__fadeIn"
          v-show="show['exit']"
        >
          Salir
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-gameover",
  data() {
    return {
      anuncio_countdown: 0,
      coins: 0,
      record: 0,
      success: 0,
      fails: 0,
      maxTime: 0,
      maxLevel: 0,
      score: 0,
      gameOverSound: null,
      muteSound: false,
      muteMusic: false,
      show: [],
    };
  },
  created: function () {
    this.gameOver();
  },
  methods: {
    async gameOver() {
      const settings = JSON.parse(
        localStorage.getItem("calcucil-settings") || "{}"
      );
      this.muteSound = settings.muteSound || false;
      this.muteMusic = settings.muteMusic || false;

      const data = JSON.parse(localStorage.getItem("calcucil-data") || "{}");
      if (!data.comesFromPlaying) {
        this.$router.replace("/");
        return;
      }
      delete data.comesFromPlaying;
      this.success = data.success || 0;
      this.fails = data.fails || 0;
      this.record = data.record || 0;
      this.coins = data.coins || 0;
      this.maxTime = data.maxTime || 0;
      this.maxLevel = data.maxLevel || 0;
      this.show = [];

      this.score = (this.success - this.fails) * this.maxTime * this.maxLevel;
      if (parseInt(this.score) > parseInt(this.record)) {
        data.record = this.record = this.score;
      }
      localStorage.setItem("calcucil-data", JSON.stringify(data));

      const base = process.env.BASE_URL;

      window.introMusic =
        window.introMusic || new Audio(base + "static/sounds/intro.mp3");

      this.gameOverSound =
        this.gameOverSound || new Audio(base + "static/sounds/game-over.mp3");

      if (!this.muteSound) {
        this.gameOverSound.play();
      }
console.log('data.lastAdTime', data.lastAdTime);
      data.lastAdTime = data.lastAdTime || 0;
      const ahora = Math.round(new Date().getTime() / 1000);
      console.log(ahora, ahora - 60, data.lastAdTime);
      if (false && ahora - 60 < data.lastAdTime) {
        this.show["anuncio"] = false;
        this.showResults();
      } else {
        data.lastAdTime = ahora;console.log(data);
        localStorage.setItem("calcucil-data", JSON.stringify(data));
        console.log(localStorage.getItem("calcucil-data"));
        this.showAd();
      }
    },

    showResults() {
      setTimeout(() => {
        this.show["success"] = true;
        this.$forceUpdate();
      }, 200);
      setTimeout(() => {
        this.show["fails"] = true;
        this.$forceUpdate();
      }, 400);
      setTimeout(() => {
        this.show["time"] = true;
        this.$forceUpdate();
      }, 600);
      setTimeout(() => {
        this.show["level"] = true;
        this.$forceUpdate();
      }, 800);
      setTimeout(() => {
        this.show["score"] = true;
        this.$forceUpdate();
      }, 1000);
      setTimeout(() => {
        this.show["record"] = true;
        this.$forceUpdate();
      }, 1200);
      setTimeout(() => {
        this.show["exit"] = true;
        this.$forceUpdate();
      }, 1500);
      setTimeout(() => {
        this.show["retry"] = true;
        if (!this.muteMusic) {
          window.introMusic.loop = true;
          window.introMusic.play();
        }
        this.$forceUpdate();
      }, 1600);
    },

    showAd() {
      this.show["anuncio"] = true;
      this.anuncio_countdown = 10;
      this.countdown(this.anuncio_countdown);
      setTimeout(() => {
        (adsbygoogle = window.adsbygoogle || []).push({});
      }, 100);
    },

    countdown(segs) {
      setTimeout(() => {
        this.anuncio_countdown = segs - 1;
        if (this.anuncio_countdown) {
          this.countdown(this.anuncio_countdown);
        }
      }, 1000);
    },

    onCloseAdClicked() {
      this.show["anuncio"] = false;
      this.showResults();
    },

    showInterstitial() {
      return new Promise((resolve, _) => {
        const device = window.device;
        const platform = device.get("platform");
        const adIds = window.adIds;

        if (platform !== "browser") {
          device.postMessage("vibrate", [600]);
          /*device.addListener("admob", (message) => {
            if (message) {
              if ([
                  'onAdDismiss',
                  'onAdFailedToLoad',
                  'onAdFailLoad',
                  'onAdFailed'
                ].includes(message.type)) {
                  resolve();
              }
            }

          }, 'game-over');
          device.postMessage("admob", {
            action: "prepareInterstitial",
            options: {
              adId: adIds[platform].interstitial,
              isTesting: false,
              autoShow: true,
            },
          });*/
        } else {
          resolve();
        }
      });
    },

    onRetryClicked() {
      this.$router.push("playing");
    },

    onBackClicked() {
      this.$router.replace("/");
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/03-GameOver.vue